import clsx from "clsx";
import { ShapeProps } from "./types";
import BlobbyStarIcon from "@mixitone/icons/blobby-star.svg";

export const BlobbyStar: React.FC<ShapeProps> = ({ color, size, className, style, children }) => {
  return (
    <div
      className={clsx("relative flex items-center justify-center", className)}
      aria-roledescription="color dot"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        ...style,
      }}
    >
      <BlobbyStarIcon className="absolute inset-0" width={size} height={size} style={{ fill: color }} />
      <span
        className="relative font-bold"
        style={{
          fontSize: `${size * 0.6}px`,
        }}
      >
        {children}
      </span>
    </div>
  );
};
